import * as React from 'react';



export default class ArrowIcon extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" className={this.props.className}  width="16" height="16" viewBox="0 0 16 16">
             <g fill="none" fillRule="evenodd">
                <circle cx="8" cy="8" r="8" fill="#F6F8F9"/>
                <path stroke="#17B9F0" strokeWidth="1.5" d="M4.667 7.333l3.149 3.334 3.517-3.334"/>
            </g>
        </svg>
    )
  }
}
